export default "__VITE_ASSET__CIu8lOsU__"